export function stickyHeader() {
  var header = document.getElementById("site-header");
  var sticky = header.offsetTop + 200;
  var stickyShow = header.offsetTop + 300;
  window.onscroll = function () {
    if (window.pageYOffset > sticky) {
      header.classList.add("site-header--sticky");
    } else {
      header.classList.remove("site-header--sticky");
    }

    if (window.pageYOffset > stickyShow) {
      header.classList.add("site-header--sticky-show");
    } else {
      header.classList.remove("site-header--sticky-show");
    }
  };
}
